<div class="campanha-cliente-filter">
    <div class="campanha-cliente-filter-itens">
        <div class="campanha-cliente-filter-item">
            <sgt-campanha-cliente-visualizacao-modo
                [ngModel]="filter.visualizacaoModo"
                (ngModelChange)="onChangeModoVisualizacao($event)"
                name="campanhaClienteFilterVisualizacaoModo"
                id="campanhaClienteFilterVisualizacaoModo">
            </sgt-campanha-cliente-visualizacao-modo>
        </div>
        <div class="campanha-cliente-filter-item">
            <sgt-cliente-cadastro-multiselect
                [(cadastros)]="filter.cadastros"
                (cadastrosChange)="onChangeCadastros()"
                defaultTitle="Cadastros">
            </sgt-cliente-cadastro-multiselect>
        </div>
        <div class="campanha-cliente-filter-item">
            <sgt-cliente-situacao-multiselect
                [(situacoes)]="filter.situacoes"
                (situacoesChange)="onChangeSituacoes()"
                defaultTitle="Situações">
            </sgt-cliente-situacao-multiselect>        
        </div>
        <div class="campanha-cliente-filter-item">
            <sgt-classificacao-tipo-multiselect
                [(idsClassificacoes)]="filter.idsClassificacoes"
                (idsClassificacoesChange)="onChangeClassificacoes()"
                [(nullOption)]="filter.classificacaoNull"
                [showNullOption]="true"
                [tipoClassificacaoCadastroCliente]="true"
                defaultTitle="Segmentos">
            </sgt-classificacao-tipo-multiselect>         
        </div>
        <div class="campanha-cliente-filter-item">
            <sgt-representante-multiselect
                [(idsRepresentantes)]="filter.idsOutrosRepresentantes"
                (idsRepresentantesChange)="onChangeRepresentantes()"
                defaultTitle="Representantes"
                [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
                [showSemRepresentante]="true"
                [(semRepresentante)]="filter.semRepresentante">
            </sgt-representante-multiselect>        
        </div>            
    </div>
    <div class="campanha-cliente-filter-options">
        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar">
            <i class="fas fa-eraser" aria-hidden="true"></i> Limpar
        </button>
    </div>
</div>